export default {
  PRODUCT_NOT_AVAILABLE: "Product is currently not available. Add it to your wishlist or check back later.", 
};
